import type { FC } from 'react';
import { useEffect, useState } from 'react';
import type { ColorValue, RefreshControlProps } from 'react-native';
import { RefreshControl } from 'react-native';

import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const Refresher: FC<RefreshControlProps> = ({
  tintColor,
  progressViewOffset,
  ...refreshControlProps
}) => {
  const theme = useAppTheme();

  // Workaround: https://github.com/facebook/react-native/issues/53987#
  // Todo: remove when issue fixed
  const [color, setColor] = useState<ColorValue>('white');
  useEffect(() => {
    setTimeout(() => setColor(tintColor ?? theme.colors.primary), 500);
  }, [tintColor, theme.colors.primary]);

  // Todo: remove when issue fixed
  const [offSet, setOffSet] = useState(0);
  useEffect(() => {
    setTimeout(() => setOffSet(progressViewOffset ?? 0), 500);
  }, [progressViewOffset]);

  return (
    <RefreshControl
      {...refreshControlProps}
      colors={[color]}
      tintColor={color}
      progressViewOffset={offSet}
    />
  );
};
